import Vue from 'vue';
import Vuex from 'vuex';
import * as types from './types';

Vue.use(Vuex);

const initState = {
    imageData: [],
    imagePath: ''
}

export default new Vuex.Store({
    state: {
        ...initState
    },
    mutations: {
        [types.MUTATE_SET_IMAGEDATA]: (state, data) => {
            state.imageData = data;
        },
        [types.MUTATE_UPDATE_IMAGEDATA]: (state, data) => {
            const detail = state.imageData.find(x => x.id === data.id);

            detail.rawData = { ...data.rawData, ...detail.rawData };
        },
        [types.MUTATE_SET_IMAGE_PATH]: (state, data) => {
            state.imagePath = data;
        },
        [types.MUTATE_ADD_DETAILS]: (state, data) => {
            const detail = state.imageData.find(x => x.index === +data.index);

            if (!detail.imageIds) detail.imageIds = [];

            detail.imageIds = [...data.imageIds, ...detail.imageIds];
        }
    },
    actions: {
        [types.SET_IMAGEDATA]: ({ commit }, data) => {
            commit(types.MUTATE_SET_IMAGEDATA, data);
        },
        [types.UPDATE_IMAGEDATA]: ({ commit }, data) => {
            commit(types.MUTATE_UPDATE_IMAGEDATA, data);
        },
        [types.SET_IMAGE_PATH]: ({ commit }, data) => {
            commit(types.MUTATE_SET_IMAGE_PATH, data);
        },
        [types.ADD_DETAILS]: ({ commit }, data) => {
            commit(types.MUTATE_ADD_DETAILS, data);
        }
    },
});
